module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f000i-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Pzkpfw IV ausf G, from Panzer-Regiment 22 of 21.Panzer-Division photographed at some time prior to the Normandy landings. Note the early muzzle brake, introduced with the 7.5cm L/43 gun, and the turret and hull Schürzen which are the first pattern and coated with Zimmerit. Another view of this tank is shown in the photograph on "), _c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 10")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1f0390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 57
// module chunks = 0